export default __webpack_public_path__ + "3a61e62d4565e002d92f7607fd029006.svg";